define('modules/form_editor/models/custom_year',['require','exports','module','./base_form_element'],function(require, exports, module){
  "use strict";
  var BaseFormElement = require("./base_form_element");

  module.exports = BaseFormElement.extend({
    name: "custom:year",
    defaultValues: {
      firstOptionInvalid: true,
      start: 1900,
      end: +(new Date()).getFullYear()
    },
    validate: function(attrs){
      if (isNaN(attrs.start) || isNaN(attrs.end) || 
          attrs.start < 1900 || attrs.start > attrs.end) 
        return new Error();
    },
  });
});

